import React from 'react'
import "../components/footer.css"

const Footer = () => {
  return (
    <div>
        <footer class="footer-section">
            <div className='text-center font-2 text-white py-5 bg-dark'>
       
                <a className='text-white text-decoration-none' target="_blank" rel="noopener noreferrer" href="https://github.com/Adarsh-K21/text-magic">See this project on Github <i class="fa-brands fa-github"></i></a>
      
          
            </div>
     
        </footer>
    </div>
  )
}

export default Footer